"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropMenu = void 0;
var _DropMenu = require("./DropMenu.styles");
var _List = require("../../../../Data/List");
var _jsxRuntime = require("react/jsx-runtime");
var DropMenu = function DropMenu(props) {
  var options = props.options,
    children = props.children,
    closeMethod = props.closeMethod;
  var styles = (0, _DropMenu.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    role: "menu",
    className: styles['cc-Menu__dropMenu'],
    children: options ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {
      children: options.map(function (option) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
          role: "menuitem",
          id: option.value.toString(),
          isSelected: option.isSelected,
          isDisabled: option.isDisabled,
          size: "small",
          color: "basic",
          onClick: function onClick() {
            closeMethod();
            option.onClick();
          },
          children: option.label
        }, option.value.toString());
      })
    }) : children
  });
};
exports.DropMenu = DropMenu;